var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiskSubtle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30775 16.7116H19.6923C19.7821 16.7116 19.8558 16.6828 19.9135 16.6251C19.9712 16.5675 20 16.4937 20 16.4039V10.8271H4V16.4039C4 16.4937 4.02883 16.5675 4.0865 16.6251C4.14417 16.6828 4.21792 16.7116 4.30775 16.7116ZM17.0565 15.0194C17.4035 15.0194 17.6988 14.898 17.9423 14.6551C18.1859 14.4123 18.3077 14.1174 18.3077 13.7704C18.3077 13.4236 18.1863 13.1283 17.9435 12.8846C17.7007 12.6411 17.4057 12.5194 17.0587 12.5194C16.7119 12.5194 16.4167 12.6408 16.173 12.8836C15.9295 13.1265 15.8077 13.4213 15.8077 13.7681C15.8077 14.1151 15.9292 14.4104 16.172 14.6539C16.4148 14.8976 16.7097 15.0194 17.0565 15.0194ZM21.5 9.32715H19.3865L17.175 7.07715H6.825L4.6135 9.32715H2.5L5.68475 6.10415C5.84875 5.93348 6.04125 5.80298 6.26225 5.71265C6.48325 5.62231 6.71575 5.57715 6.95975 5.57715H17.0402C17.2843 5.57715 17.5168 5.62231 17.7378 5.71265C17.9588 5.80298 18.1512 5.93348 18.3152 6.10415L21.5 9.32715ZM4.30775 18.2116C3.81058 18.2116 3.385 18.0346 3.031 17.6806C2.677 17.3266 2.5 16.9011 2.5 16.4039V9.32715H21.5V16.4039C21.5 16.9011 21.323 17.3266 20.969 17.6806C20.615 18.0346 20.1894 18.2116 19.6923 18.2116H4.30775Z",
    fill: "#6D7A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskSubtle);
export default __webpack_public_path__ + "static/media/disk_subtle.614a384d22d185326d8b9d16d2d22720.svg";
export { ForwardRef as ReactComponent };